export default __webpack_public_path__ + "static/media/logofontwhite.74d4feec.png";